import React from 'react'
import styles from './OfferHistoryItem.module.scss'
import { useCallback, useState } from 'react'
import { formatPrizeTypeLabel, INCENTIVE_BASIS_LABEL } from '../../../utils/incentiveDisplay'

const OfferHistoryItem = ({ data, haveToIndicateChanges = true }) => {
	const [domesticOverseasSwapContent, setDomesticOverseasSwapContent] = useState(true)

	const sortIncentiveSettings = useCallback((incentiveSettings) => {
		if (!incentiveSettings || !Array.isArray(incentiveSettings)) {
			return []
		}

		const sorted = incentiveSettings.sort((a, b) => {
			// startRank가 null이나 undefined인 경우 처리
			const aRank = a.startRank || 999
			const bRank = b.startRank || 999
			return aRank - bRank
		})

		return sorted
	}, [])

	const formatYear = useCallback((dateString) => {
		if (!dateString) return ''
		// YYYY-MM-DD 형식에서 YYYY를 YY로 변환 (앞 두 글자 제거)
		return dateString.replace(/^\d{2}(\d{2}-)/, '$1')
	}, [])

	const formatNumber = useCallback((num) => {
		if (!num) return '0'
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
	}, [])

	const sortTourByDate = (tour) => {
		if (!tour || !Array.isArray(tour)) {
			return []
		}
		return tour.sort((a, b) => {
			const startDateA = new Date(a.tour.started_at)
			const startDateB = new Date(b.tour.started_at)

			// 시작 날짜가 다르면 시작 날짜로 정렬 (빠른 순)
			if (startDateA.getTime() !== startDateB.getTime()) {
				return startDateA - startDateB
			}

			// 시작 날짜가 같으면 끝나는 날짜로 정렬 (빨리 끝나는 순)
			const endDateA = new Date(a.tour.ended_at)
			const endDateB = new Date(b.tour.ended_at)
			return endDateA - endDateB
		})
	}

	console.log('data:', data)

	return (
		<div className={styles.container}>
			<div className={styles.createdTime}>{data.createdAt.slice(2, 10)}</div>
			{haveToIndicateChanges &&
				(!data?.changedFields || data?.changedFields.length === 0) && (
					<div className={styles.noChangesMessage}>변경사항이 없습니다.</div>
				)}
			{data?.termContract && (
				<>
					<div
						className={`${styles.applyTaxContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('termContract.isSalaryTaxIncluded')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.applyTaxLabel}>세금 적용 여부</div>
						<div className={styles.applyTaxContent}>
							{!data?.termContract.isSalaryTaxIncluded ? '세전' : '세후'}
						</div>
					</div>
					<div
						className={`${styles.payPeriodContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('termContract.payrollCycles')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.payPeriodLabel}>임금 지급 주기</div>
						<div className={styles.payPeriodContent}>
							{data?.termContract.payrollCycles === 'weekly' ? '주급' : '일시불제'}
						</div>
					</div>
					<div
						className={`${styles.periodSalaryContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('termContract.salaryAmountForPeriod')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.periodSalaryLabel}>기간 급여액</div>
						<div className={styles.periodSalaryContent}>
							{formatNumber(data?.termContract.salaryAmountForPeriod)} 원
						</div>
					</div>
					<div
						className={`${styles.incentiveOptionContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('termContract.prizeType')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.incentiveOptionLabel}>{INCENTIVE_BASIS_LABEL}</div>
						<div className={styles.incentiveOptionContent}>
							{formatPrizeTypeLabel(data?.termContract.prizeType)}
						</div>
					</div>
					<div
						className={`${styles.incentiveSettingsContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('termContract.incentives')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.incentiveSettingsLabel}>인센티브 금액</div>
						<div className={styles.incentiveSettingsContent}>
							{sortIncentiveSettings(data?.termContract.incentives).map(
								(setting, mapIndex) => {
									if (setting.percentage === null && setting.endRank === null)
										return null
									console.log('setting:', setting, 'mapIndex:', mapIndex)
									const displayRank =
										mapIndex === 0 || setting.startRank === 1
											? '우승 : '
											: setting.startRank +
												(setting.endRank !== null
													? setting.endRank === 0
														? ` ~ CUT :  `
														: ` ~ ${setting.endRank} :  `
													: '~ ')
									const displayPercentage =
										setting.percentage !== null
											? `  ${setting.percentage}%`
											: '미입력'
									return (
										<div
											key={setting.index}
											className={styles.incentiveDisplayItem}>
											<div>{displayRank}</div>
											<div>{displayPercentage}</div>
										</div>
									)
								},
							)}
						</div>
					</div>
					<div
						className={`${styles.expenseReimbursementContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('termContract.expenseReimbursement')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.expenseReimbursementLabel}>해외대회 지원금</div>
						<div className={styles.expenseReimbursementContent}>
							{data?.termContract.expenseReimbursement === 0
								? '미지원'
								: formatNumber(data?.termContract.expenseReimbursement)}
							{'%'}
						</div>
					</div>
					<div
						className={`${styles.wearSponserHatContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('termContract.wearSponsoredHat')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.wearSponserHatLabel}>스폰서 모자 착용 여부</div>
						<div className={styles.wearSponserHatContent}>
							{data?.termContract.wearSponsoredHat ? '착용' : '미착용'}
						</div>
					</div>
				</>
			)}
			{data?.domesticContract && data?.overseasContract && (
				<>
					<div className={styles.domesticOverseasSwapContainer}>
						<button
							className={
								domesticOverseasSwapContent
									? styles.seeDomesticChosen
									: styles.seeDomesticUnchosen
							}
							onClick={() => setDomesticOverseasSwapContent((prev) => !prev)}>
							국내
						</button>
						<button
							className={
								domesticOverseasSwapContent
									? styles.seeOverseasUnchosen
									: styles.seeOverseasChosen
							}
							onClick={() => setDomesticOverseasSwapContent((prev) => !prev)}>
							해외
						</button>
					</div>
					{domesticOverseasSwapContent && (
						<>
							<div
								className={`${styles.applyTaxContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes(
										'domesticContract.isSalaryTaxIncluded',
									)
										? styles.changedField
										: ''
								}`}>
								<div className={styles.applyTaxLabel}>세금 적용 여부</div>
								<div className={styles.applyTaxContent}>
									{data?.domesticContract.isSalaryTaxIncluded ? '세후' : '세전'}
								</div>
							</div>
							<div
								className={`${styles.payPeriodContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes('domesticContract.payrollCycles')
										? styles.changedField
										: ''
								}`}>
								<div className={styles.payPeriodLabel}>임금 지급 주기</div>
								<div className={styles.payPeriodContent}>
									{data?.domesticContract.payrollCycles === 'weekly'
										? '주급'
										: '일시불제'}
								</div>
							</div>
							<div
								className={`${styles.cutPassContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes(
										'domesticContract.weeklySalaryCutThrough',
									)
										? styles.changedField
										: ''
								}`}>
								<div className={styles.cutPassLabel}>컷통과</div>
								<div className={styles.cutPassContent}>
									{formatNumber(data?.domesticContract.weeklySalaryCutThrough)} 원
								</div>
							</div>
							<div
								className={`${styles.cutOutContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes(
										'domesticContract.weeklySalaryCutFail',
									)
										? styles.changedField
										: ''
								}`}>
								<div className={styles.cutOutLabel}>컷탈락</div>
								<div className={styles.cutOutContent}>
									{formatNumber(data?.domesticContract.weeklySalaryCutFail)} 원
								</div>
							</div>
							<div
								className={`${styles.incentiveOptionContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes('domesticContract.prizeType')
										? styles.changedField
										: ''
								}`}>
								<div className={styles.incentiveOptionLabel}>
									{INCENTIVE_BASIS_LABEL}
								</div>
								<div className={styles.incentiveOptionContent}>
									{formatPrizeTypeLabel(data?.domesticContract.prizeType)}
								</div>
							</div>
							<div
								className={`${styles.incentiveSettingsContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes('domesticContract.incentives')
										? styles.changedField
										: ''
								}`}>
								<div className={styles.incentiveSettingsLabel}>인센티브 금액</div>
								<div className={styles.incentiveSettingsContent}>
									{sortIncentiveSettings(data?.domesticContract.incentives).map(
										(setting, mapIndex) => {
											if (
												setting.percentage === null &&
												setting.endRank === null
											)
												return null
											const displayRank =
												mapIndex === 0
													? '우승 : '
													: setting.startRank +
														(setting.endRank !== null
															? setting.endRank === 0
																? ` ~ CUT :  `
																: ` ~ ${setting.endRank} :  `
															: '~ ')
											const displayPercentage =
												setting.percentage !== null
													? `  ${setting.percentage}%`
													: '미입력'
											return (
												<div
													key={setting.index}
													className={styles.incentiveDisplayItem}>
													<div>{displayRank}</div>
													<div>{displayPercentage}</div>
												</div>
											)
										},
									)}
								</div>
							</div>
							<div
								className={`${styles.expenseReimbursementJejuContainer} ${
									(haveToIndicateChanges &&
										data?.changedFields?.includes(
											'domesticContract.expenseReimbursementJeju',
										)) ||
									data?.changedFields?.includes(
										'domesticContract.jejuTournamentParticipation',
									)
										? styles.changedField
										: ''
								}`}>
								<div className={styles.expenseReimbursementJejuLabel}>
									제주 대회 지원금
								</div>
								<div className={styles.expenseReimbursementJejuContent}>
									{data?.domesticContract.expenseReimbursementJeju === 0
										? '미지원'
										: formatNumber(
												data?.domesticContract.expenseReimbursementJeju,
											) + ' 원'}
								</div>
							</div>
							<div
								className={`${styles.wearSponserHatContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes(
										'domesticContract.wearSponsoredHat',
									)
										? styles.changedField
										: ''
								}`}>
								<div className={styles.wearSponserHatLabel}>
									스폰서 모자 착용 여부
								</div>
								<div className={styles.wearSponserHatContent}>
									{data?.domesticContract.wearSponsoredHat ? '착용' : '미착용'}
								</div>
							</div>
						</>
					)}
					{!domesticOverseasSwapContent && (
						<>
							<div
								className={`${styles.applyTaxContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes(
										'overseasContract.isSalaryTaxIncluded',
									)
										? styles.changedField
										: ''
								}`}>
								<div className={styles.applyTaxLabel}>세금 적용 여부</div>
								<div className={styles.applyTaxContent}>
									{!data?.overseasContract.isSalaryTaxIncluded ? '세후' : '세전'}
								</div>
							</div>
							<div
								className={`${styles.payPeriodContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes('overseasContract.payrollCycles')
										? styles.changedField
										: ''
								}`}>
								<div className={styles.payPeriodLabel}>임금 지급 주기</div>
								<div className={styles.payPeriodContent}>
									{data?.overseasContract.payrollCycles === 'weekly'
										? '주급'
										: '일시불제'}
								</div>
							</div>
							<div
								className={`${styles.cutPassContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes(
										'overseasContract.weeklySalaryCutThrough',
									)
										? styles.changedField
										: ''
								}`}>
								<div className={styles.cutPassLabel}>컷통과</div>
								<div className={styles.cutPassContent}>
									{formatNumber(data?.overseasContract.weeklySalaryCutThrough)} 원
								</div>
							</div>
							<div
								className={`${styles.cutOutContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes(
										'overseasContract.weeklySalaryCutFail',
									)
										? styles.changedField
										: ''
								}`}>
								<div className={styles.cutOutLabel}>컷탈락</div>
								<div className={styles.cutOutContent}>
									{formatNumber(data?.overseasContract.weeklySalaryCutFail)} 원
								</div>
							</div>
							<div
								className={`${styles.incentiveOptionContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes('overseasContract.prizeType')
										? styles.changedField
										: ''
								}`}>
								<div className={styles.incentiveOptionLabel}>
									{INCENTIVE_BASIS_LABEL}
								</div>
								<div className={styles.incentiveOptionContent}>
									{formatPrizeTypeLabel(data?.overseasContract.prizeType)}
								</div>
							</div>
							<div
								className={`${styles.incentiveSettingsContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes('overseasContract.incentives')
										? styles.changedField
										: ''
								}`}>
								<div className={styles.incentiveSettingsLabel}>인센티브 금액</div>
								<div className={styles.incentiveSettingsContent}>
									{sortIncentiveSettings(data?.overseasContract.incentives).map(
										(setting, mapIndex) => {
											if (
												setting.percentage === null &&
												setting.endRank === null
											)
												return null
											const displayRank =
												mapIndex === 0
													? '우승 : '
													: setting.startRank +
														(setting.endRank !== null
															? setting.endRank === 0
																? ` ~ CUT :  `
																: ` ~ ${setting.endRank} :  `
															: '~ ')
											const displayPercentage =
												setting.percentage !== null
													? `  ${setting.percentage}%`
													: '미입력'
											return (
												<div
													key={setting.index}
													className={styles.incentiveDisplayItem}>
													<div>{displayRank}</div>
													<div>{displayPercentage}</div>
												</div>
											)
										},
									)}
								</div>
							</div>
							<div
								className={`${styles.expenseReimbursementContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes(
										'overseasContract.expenseReimbursement',
									)
										? styles.changedField
										: ''
								}`}>
								<div className={styles.expenseReimbursementLabel}>
									해외 대회 지원금
								</div>
								<div className={styles.expenseReimbursementContent}>
									{data?.overseasContract.expenseReimbursement === 0
										? '미지원'
										: formatNumber(
												data?.overseasContract.expenseReimbursement,
											) + ' %'}
								</div>
							</div>
							<div
								className={`${styles.wearSponserHatContainer} ${
									haveToIndicateChanges &&
									data?.changedFields?.includes(
										'overseasContract.wearSponsoredHat',
									)
										? styles.changedField
										: ''
								}`}>
								<div className={styles.wearSponserHatLabel}>
									스폰서 모자 착용 여부
								</div>
								<div className={styles.wearSponserHatContent}>
									{data?.overseasContract.wearSponsoredHat ? '착용' : '미착용'}
								</div>
							</div>
						</>
					)}
				</>
			)}

			{data?.overseasContract && !data?.domesticContract && (
				<>
					<div
						className={`${styles.applyTaxContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('overseasContract.isSalaryTaxIncluded')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.applyTaxLabel}>세금 적용 여부</div>
						<div className={styles.applyTaxContent}>
							{!data?.overseasContract.isSalaryTaxIncluded ? '세후' : '세전'}
						</div>
					</div>
					<div
						className={`${styles.payPeriodContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('overseasContract.payrollCycles')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.payPeriodLabel}>임금 지급 주기</div>
						<div className={styles.payPeriodContent}>
							{data?.overseasContract.payrollCycles === 'weekly'
								? '주급'
								: '일시불제'}
						</div>
					</div>
					<div
						className={`${styles.cutPassContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('overseasContract.weeklySalaryCutThrough')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.cutPassLabel}>컷통과</div>
						<div className={styles.cutPassContent}>
							{formatNumber(data?.overseasContract.weeklySalaryCutThrough)} 원
						</div>
					</div>
					<div
						className={`${styles.cutOutContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('overseasContract.weeklySalaryCutFail')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.cutOutLabel}>컷탈락</div>
						<div className={styles.cutOutContent}>
							{formatNumber(data?.overseasContract.weeklySalaryCutFail)} 원
						</div>
					</div>
					<div
						className={`${styles.incentiveOptionContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('overseasContract.prizeType')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.incentiveOptionLabel}>{INCENTIVE_BASIS_LABEL}</div>
						<div className={styles.incentiveOptionContent}>
							{formatPrizeTypeLabel(data?.overseasContract.prizeType)}
						</div>
					</div>
					<div
						className={`${styles.incentiveSettingsContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('overseasContract.incentives')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.incentiveSettingsLabel}>인센티브 금액</div>
						<div className={styles.incentiveSettingsContent}>
							{sortIncentiveSettings(data?.overseasContract.incentives).map(
								(setting, mapIndex) => {
									if (setting.percentage === null && setting.endRank === null)
										return null
									const displayRank =
										mapIndex === 0
											? '우승 : '
											: setting.startRank +
												(setting.endRank !== null
													? setting.endRank === 0
														? ` ~ CUT :  `
														: ` ~ ${setting.endRank} :  `
													: '~ ')
									const displayPercentage =
										setting.percentage !== null
											? `  ${setting.percentage}%`
											: '미입력'
									return (
										<div
											key={setting.index}
											className={styles.incentiveDisplayItem}>
											<div>{displayRank}</div>
											<div>{displayPercentage}</div>
										</div>
									)
								},
							)}
						</div>
					</div>
					<div
						className={`${styles.expenseReimbursementContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('overseasContract.expenseReimbursement')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.expenseReimbursementLabel}>해외 대회 지원금</div>
						<div className={styles.expenseReimbursementContent}>
							{data?.overseasContract.expenseReimbursement === 0
								? '미지원'
								: formatNumber(data?.overseasContract.expenseReimbursement) + ' %'}
						</div>
					</div>
					<div
						className={`${styles.wearSponserHatContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('overseasContract.wearSponsoredHat')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.wearSponserHatLabel}>스폰서 모자 착용 여부</div>
						<div className={styles.wearSponserHatContent}>
							{data?.overseasContract.wearSponsoredHat ? '착용' : '미착용'}
						</div>
					</div>
				</>
			)}
			{data?.domesticContract && !data?.overseasContract && (
				<>
					<div
						className={`${styles.applyTaxContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('domesticContract.isSalaryTaxIncluded')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.applyTaxLabel}>세금 적용 여부</div>
						<div className={styles.applyTaxContent}>
							{!data?.domesticContract.isSalaryTaxIncluded ? '세후' : '세전'}
						</div>
					</div>
					<div
						className={`${styles.payPeriodContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('domesticContract.payrollCycles')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.payPeriodLabel}>임금 지급 주기</div>
						<div className={styles.payPeriodContent}>
							{data?.domesticContract.payrollCycles === 'weekly'
								? '주급'
								: '일시불제'}
						</div>
					</div>
					<div
						className={`${styles.cutPassContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('domesticContract.weeklySalaryCutThrough')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.cutPassLabel}>컷통과</div>
						<div className={styles.cutPassContent}>
							{formatNumber(data?.domesticContract.weeklySalaryCutThrough)} 원
						</div>
					</div>
					<div
						className={`${styles.cutOutContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('domesticContract.weeklySalaryCutFail')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.cutOutLabel}>컷탈락</div>
						<div className={styles.cutOutContent}>
							{formatNumber(data?.domesticContract.weeklySalaryCutFail)} 원
						</div>
					</div>
					<div
						className={`${styles.incentiveOptionContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('domesticContract.prizeType')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.incentiveOptionLabel}>{INCENTIVE_BASIS_LABEL}</div>
						<div className={styles.incentiveOptionContent}>
							{formatPrizeTypeLabel(data?.domesticContract.prizeType)}
						</div>
					</div>
					<div
						className={`${styles.incentiveSettingsContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('domesticContract.incentives')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.incentiveSettingsLabel}>인센티브 금액</div>
						<div className={styles.incentiveSettingsContent}>
							{sortIncentiveSettings(data?.domesticContract.incentives).map(
								(setting, mapIndex) => {
									if (setting.percentage === null && setting.endRank === null)
										return null
									const displayRank =
										mapIndex === 0
											? '우승 : '
											: setting.startRank +
												(setting.endRank !== null
													? setting.endRank === 0
														? ` ~ CUT :  `
														: ` ~ ${setting.endRank} :  `
													: '~ ')
									const displayPercentage =
										setting.percentage !== null
											? `  ${setting.percentage}%`
											: '미입력'
									return (
										<div
											key={setting.index}
											className={styles.incentiveDisplayItem}>
											<div>{displayRank}</div>
											<div>{displayPercentage}</div>
										</div>
									)
								},
							)}
						</div>
					</div>
					<div
						className={`${styles.expenseReimbursementJejuContainer} ${
							(haveToIndicateChanges &&
								data?.changedFields?.includes(
									'domesticContract.expenseReimbursementJeju',
								)) ||
							data?.changedFields?.includes(
								'domesticContract.jejuTournamentParticipation',
							)
								? styles.changedField
								: ''
						}`}>
						<div className={styles.expenseReimbursementJejuLabel}>제주 대회 지원금</div>
						<div className={styles.expenseReimbursementJejuContent}>
							{data?.domesticContract.expenseReimbursementJeju === 0
								? '미지원'
								: formatNumber(data?.domesticContract.expenseReimbursementJeju) +
									' 원'}
						</div>
					</div>
					<div
						className={`${styles.wearSponserHatContainer} ${
							haveToIndicateChanges &&
							data?.changedFields?.includes('domesticContract.wearSponsoredHat')
								? styles.changedField
								: ''
						}`}>
						<div className={styles.wearSponserHatLabel}>스폰서 모자 착용 여부</div>
						<div className={styles.wearSponserHatContent}>
							{data?.domesticContract.wearSponsoredHat ? '착용' : '미착용'}
						</div>
					</div>
				</>
			)}
		</div>
	)
}

export default OfferHistoryItem
